import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
  Input,
} from "@chakra-ui/react";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

/**
 * Renders the beneficiary form
 * @param {Function} register - The form registration function
 * @param {Object} errors - The form errors object
 * @returns The beneficiary form
 */
const BeneficiaryForm = ({ register, errors }) => {
  const { t } = useTranslation();

  return (
    <Grid
      gap={"8px"}
      templateColumns={{ base: "repeat(1, 1fr)", xl: "repeat(7, 1fr)" }}
      templateRows={{ base: "repeat(1, 1fr)", xl: "repeat(2, 1fr)" }}
    >
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl isInvalid={errors.firstName}>
          <FormLabel fontSize={12} htmlFor={"firstName"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.firstName.title</Trans>
          </FormLabel>
          <Input
            id={"firstName"}
            placeholder={t("beneficiaryFile.form.firstName.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("firstName", {
              required: t("beneficiaryFile.form.firstName.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors.firstName && errors.firstName.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"gender"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.gender.title</Trans>
          </FormLabel>
          <Input
            id={"gender"}
            placeholder={t("beneficiaryFile.form.gender.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("gender")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"birthdate"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.birthdate.title</Trans>
          </FormLabel>
          <Input id={"birthdate"} type={"date"} style={{ colorScheme: "dark" }} backgroundColor={"#2D313A"} {...register("birthdate")} />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"email"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.email.title</Trans>
          </FormLabel>
          <Input
            id={"email"}
            placeholder={t("beneficiaryFile.form.email.placeholder")}
            type={"email"}
            backgroundColor={"#2D313A"}
            {...register("email")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"postalCode"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.postalCode.title</Trans>
          </FormLabel>
          <Input
            id={"postalCode"}
            placeholder={t("beneficiaryFile.form.postalCode.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("postalCode")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={{ base: 1, xl: 2 }} rowSpan={1}>
        <FormControl isInvalid={errors.city}>
          <FormLabel fontSize={12} htmlFor={"city"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.city.title</Trans>
          </FormLabel>
          <Input
            id={"city"}
            placeholder={t("beneficiaryFile.form.city.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("city")}
          />
          <FormErrorMessage fontSize={8}>
            {errors.city && errors.city.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl isInvalid={errors.lastName}>
          <FormLabel fontSize={12} htmlFor={"lastName"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.lastName.title</Trans>
          </FormLabel>
          <Input
            id={"lastName"}
            placeholder={t("beneficiaryFile.form.lastName.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("lastName", {
              required: t("beneficiaryFile.form.lastName.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors.lastName && errors.lastName.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"customerNumber"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.customerNumber.title</Trans>
          </FormLabel>
          <Input
            id={"customerNumber"}
            placeholder={t("beneficiaryFile.form.customerNumber.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("customerNumber")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl isInvalid={errors.phoneNumber}>
          <FormLabel fontSize={12} htmlFor={"phoneNumber"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.phoneNumber.title</Trans>
          </FormLabel>
          <Input
            id={"phoneNumber"}
            placeholder={t("beneficiaryFile.form.phoneNumber.placeholder")}
            type={"tel"}
            backgroundColor={"#2D313A"}
            {...register("phoneNumber", {
              required: t("beneficiaryFile.form.phoneNumber.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors.phoneNumber && errors.phoneNumber.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={{ base: 1, xl: 2 }} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"address"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.address.title</Trans>
          </FormLabel>
          <Input
            id={"address"}
            placeholder={t("beneficiaryFile.form.address.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("address")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={{ base: 1, xl: 2 }} rowSpan={1}>
        <FormControl isInvalid={errors.country}>
          <FormLabel fontSize={12} htmlFor={"country"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.country.title</Trans>
          </FormLabel>
          <Input
            id={"country"}
            placeholder={t("beneficiaryFile.form.country.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("country")}
          />
          <FormErrorMessage fontSize={8}>
            {errors.country && errors.country.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
    </Grid>
  );
};

export default BeneficiaryForm;
